import { createRouter, createWebHistory } from 'vue-router';

import Layout from '@/layouts/Layout.vue';

import Lists from '@/pages/Lists.vue';
import Groups from '@/pages/Groups.vue';
import Group from '@/pages/Group.vue';
import Settings from '@/pages/Settings.vue';

import PageNotFound from '@/pages/PageNotFound.vue';

const routes = [
	{
		path: '/',
		redirect: '/lists',
	},
	{
		path: '/',
		component: Layout,
		children: [
			{
				name: 'lists',
				path: 'lists',
				component: Lists,
			},
			{
				name: 'groups',
				path: 'groups',
				component: Groups,
			},
			{
				name: 'group-details',
				path: 'groups/:id',
				component: Group,
			},
			{
				name: 'settings',
				path: 'settings',
				component: Settings,
			},
		],
	},
	{
		name: "page-not-found",
		path: "/:pathMatch(.*)*",
		component: PageNotFound,
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 1. Если браузер нажал "Назад/Вперед", возвращаем сохраненную позицию
		if (savedPosition) {
			return savedPosition;
		}

		// 2. Если в роуте прописано не скроллить — ничего не делаем
		if (to.matched.some(r => r.meta.noScroll)) {
			return false; // Сохраняет текущую позицию
		}

		// 3. По умолчанию всегда скроллим вверх
		return { top: 0, behavior: "smooth" }; // Можно добавить плавность
	},
});

export default router;
